export default __webpack_public_path__ + "static/media/claro-2.ac92907a.JPG";